import { render, staticRenderFns } from "./ResumeAIReview.vue?vue&type=template&id=06e21842&scoped=true&"
import script from "./ResumeAIReview.vue?vue&type=script&lang=js&"
export * from "./ResumeAIReview.vue?vue&type=script&lang=js&"
import style0 from "./ResumeAIReview.vue?vue&type=style&index=0&id=06e21842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e21842",
  null
  
)

export default component.exports